/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import "../css/integration.css";
import { Row, Col } from "reactstrap";
import Tabs from "./Settings/Tabs";
import PaypalSettings from "./Settings/PaypalSettings";
import Mollie from "./Settings/Mollie";
import Account from "./Account";
import Stripe from "./Settings/Stripe";
import Key from "./Settings/Key";
import Integration from "./Integration";
import General from "./Settings/General";
import BannerWoo from "./Dashboard/BannerWoo";
import MultiStore from "./Settings/MultiStore";
import CourierMapping from "./Settings/CourierMapping";
import Dispute from "./Dispute";
import DigitalProduct from "./Settings/DigitalProduct";

const Settings = () => {
	const [tabSelected, setTabSelected] = useState(1);
	const changeTab = (tab) => {
		setTabSelected(tab);
	};
	return (
		<div style={{ marginTop: "20px" }} className="settings-page">
			<div>
				<BannerWoo />
			</div>
			<Row>
				<Col xs="12" sm="12" md="3">
					<Tabs changeTab={changeTab} />
				</Col>
				<Col xs="12" sm="12" md="9">
					<Row>
						<Col md={12}>
							{tabSelected === 1 ? <PaypalSettings /> : null}
							{tabSelected === 2 ? <Stripe /> : null}
							{tabSelected === 5 ? <CourierMapping /> : null}
							{tabSelected === 3 ? <MultiStore /> : null}
							{tabSelected === 4 ? <Integration /> : null}
							{tabSelected === 6 ? <General /> : null}
							{tabSelected === 7 ? <DigitalProduct /> : null}
							{tabSelected === 8 ? <Dispute /> : null}
						</Col>
					</Row>
				</Col>
			</Row>
		</div>
	);
};

export default Settings;
